/* eslint-disable react/prop-types */
import Accordion from '../../sharedmodules/components/accordion';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import React from 'react';

const UserAccordion = ({
    title, closeOpenModal, childRoutes,
}) => {

    const body = childRoutes.map((item) => (
        <li>
            <NavLink activeClassName="selected" to={item.path}><FormattedMessage id={item.title} /></NavLink>
        </li>

    ));
    return (
        <div>
            <Accordion
                accordion="props.claimsAccordion"
                body={body}
                title={title}
                handleAddAccordinanContent={closeOpenModal}
            />
        </div>
    );

};

export default UserAccordion;
